﻿import {NamedValue, translation} from "@2d-front-monorepo/core";
import AttachmentStatus from "./enums/AttachmentStatus";
import AttachmentType from "./enums/AttachmentType";
import {attachmentStatusLabel, attachmentTypeLabel, permitStatusLabel, PermitStatusType} from "./index";

export default class EnumLists {
	private static _permitStatusTypes: NamedValue<PermitStatusType>[] | undefined;
	private static _documentStatusTypes: NamedValue<AttachmentStatus>[] | undefined;
	private static _attachmentTypes: NamedValue<AttachmentType>[] | undefined;

	static permitStatusType(): NamedValue<PermitStatusType>[] {
		return this._permitStatusTypes ??= [
			{label: translation(permitStatusLabel(PermitStatusType.Submitted)), value: PermitStatusType.Submitted},
			{label: translation(permitStatusLabel(PermitStatusType.UnderReview)), value: PermitStatusType.UnderReview},
			{
				label: translation(permitStatusLabel(PermitStatusType.RequestMoreInformation)),
				value: PermitStatusType.RequestMoreInformation
			},
			{label: translation(permitStatusLabel(PermitStatusType.Approved)), value: PermitStatusType.Approved},
			{label: translation(permitStatusLabel(PermitStatusType.Rejected)), value: PermitStatusType.Rejected},
			{label: translation(permitStatusLabel(PermitStatusType.Active)), value: PermitStatusType.Active},
			{label: translation(permitStatusLabel(PermitStatusType.Cancelled)), value: PermitStatusType.Cancelled},
			{label: translation(permitStatusLabel(PermitStatusType.AboutToExpire)), value: PermitStatusType.AboutToExpire},
			{label: translation(permitStatusLabel(PermitStatusType.Expired)), value: PermitStatusType.Expired}
		];
	}

	static documentStatusType(): NamedValue<AttachmentStatus>[] {
		return this._documentStatusTypes ??= [
			{label: translation(attachmentStatusLabel(AttachmentStatus.Submitted)), value: AttachmentStatus.Submitted},
			{label: translation(attachmentStatusLabel(AttachmentStatus.Approved)), value: AttachmentStatus.Approved},
			{label: translation(attachmentStatusLabel(AttachmentStatus.Rejected)), value: AttachmentStatus.Rejected},
			{label: translation(attachmentStatusLabel(AttachmentStatus.Expired)), value: AttachmentStatus.Expired}
		];
	}

	static attachmentType(): NamedValue<AttachmentType>[] {
		return this._attachmentTypes ??= [
			{label: translation(attachmentTypeLabel(AttachmentType.DriverLicense)), value: AttachmentType.DriverLicense},
			{label: translation(attachmentTypeLabel(AttachmentType.ProofOfEmployment)), value: AttachmentType.ProofOfEmployment},
			{label: translation(attachmentTypeLabel(AttachmentType.ProofOfResidency)), value: AttachmentType.ProofOfResidency},
			{label: translation(attachmentTypeLabel(AttachmentType.VehicleRegistration)), value: AttachmentType.VehicleRegistration},
			{label: translation(attachmentTypeLabel(AttachmentType.FamilyVehicle)), value: AttachmentType.FamilyVehicle},
			{label: translation(attachmentTypeLabel(AttachmentType.BusinessVehicle)), value: AttachmentType.BusinessVehicle},
			{label: translation(attachmentTypeLabel(AttachmentType.OverweightVehicle)), value: AttachmentType.OverweightVehicle},
			{label: translation(attachmentTypeLabel(AttachmentType.BankTransferId)), value: AttachmentType.BankTransferId},
			{label: translation(attachmentTypeLabel(AttachmentType.MiscellaneousDocument)), value: AttachmentType.MiscellaneousDocument}
		];
	}
}
